import { render, staticRenderFns } from "./SquareTagManageView.vue?vue&type=template&id=5bee0a21&scoped=true"
import script from "./SquareTagManageView.vue?vue&type=script&lang=js"
export * from "./SquareTagManageView.vue?vue&type=script&lang=js"
import style0 from "./SquareTagManageView.vue?vue&type=style&index=0&id=5bee0a21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bee0a21",
  null
  
)

export default component.exports